import type { FC } from 'react';

import { CheckOutlined } from '@ant-design/icons';

import styles from './style.module.less';

type StepIndicatorProps = {
  total: number;
  active: number; // 1-based index
  onStepClick?: (step: number) => void;
};

const stepLabels = {
  1: 'Dados Financeiros',
  2: 'Template',
  3: 'Confirmação',
};

export const StepIndicator: FC<StepIndicatorProps> = ({ total, active, onStepClick }) => {
  const steps = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <div className={styles.wrapper}>
      {steps.map((step, idx) => {
        const isActive = step === active;
        const isCompleted = step < active;
        const isLast = idx === steps.length - 1;

        return (
          <div key={step} className={styles.stepItem}>
            <div className={styles.stepContainer}>
              <button
                type="button"
                className={[
                  styles.step,
                  isActive ? styles.active : '',
                  isCompleted ? styles.completed : '',
                ].join(' ')}
                onClick={() => onStepClick?.(step)}
                aria-current={isActive ? 'step' : undefined}
                aria-label={`Etapa ${step}: ${stepLabels[step as keyof typeof stepLabels]}`}
              >
                {isCompleted ? <CheckOutlined /> : step}
              </button>
              <span className={[styles.stepLabel, isActive ? styles.labelActive : ''].join(' ')}>
                {stepLabels[step as keyof typeof stepLabels]}
              </span>
            </div>
            {!isLast && (
              <div className={[styles.connector, isCompleted ? styles.completed : ''].join(' ')} />
            )}
          </div>
        );
      })}
    </div>
  );
};
